/**
 * The importer for a statement from a bank OKANE knows nothing about.
 *
 * It reads the sheet by looking at it — finding the header row, the date
 * column, the amounts — and it will not claim a file, so it is what you get
 * when no bank's own importer recognises one.
 *
 * Its rule for "already imported" is the strictest one available: same day,
 * same amount, same description. Without knowing a bank's habits, a row two
 * days away is a different row, and wrongly skipping a real transaction is a
 * worse mistake than importing one twice — you can see and delete a double,
 * but you cannot see something that never arrived.
 */
import { SAME_DAY, readStatement } from '../statement.js'

export default {
  id: 'generic',
  /** Named in the catalogues under `importer.<id>`. */
  read: (rows, options) => readStatement(rows, options),
  matchRule: () => SAME_DAY,
}
